<div class="data-table-item container-fluid p-0" (click)="goTo()">
  <div class="row ml-2 mr-2">
    <div *ngIf="!!showRowNumber" class="col col-1">
      <span class="row-number">{{index}}</span>
    </div>

    <div class="col col-2" *ngIf="showTypeImage">
      <span class="row-image"><i class="icon {{fileIconType}}"></i></span>
    </div>

    <div class="col col-5 overflow-hidden">
        <span class="row-name">{{file.displayName}}</span>
    </div>

    <div class="col col-1" *ngIf="!showTypeImage">
      <span class="row-type text-uppercase">{{file.contentType || file.source}}</span>
    </div>

    <div class="col col-2" *ngIf="file.author">
      <span class="row-author text-uppercase">{{file.author?.name}}</span>
    </div>

    <div class="col col-2" *ngIf="file.createdTime">
      <span class="row-date text-uppercase">{{file.createdTime | date : 'mediumDate'}}</span>
    </div>

    <div class="col row-controls" [class.col-2]="showTypeImage" [class.col-1]="!showTypeImage" *ngIf="!hideDeleteButton">
      <a class="nav-link p-0" (click)="onDelete($event)">
        <span><i class="icon icon-trash" aria-hidden="true"></i></span>
      </a>
    </div>
  </div>
</div>
